(function (root, factory) {
  var api = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (root && root.document) {
    api.start(root);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var CHOICE_LABEL = 'Choisissez votre prise';
  var RESOLVING_LABEL = 'Mise à jour…';

  function normalize(value) {
    return String(value || '').trim().toLocaleLowerCase('fr-FR');
  }

  function stripAccents(value) {
    var text = String(value || '');
    return text.normalize ? text.normalize('NFD').replace(/[̀-ͯ]/g, '') : text;
  }

  function isPlugOption(name) {
    var normalized = stripAccents(normalize(name));
    return normalized === 'prise'
      || normalized === 'type de prise'
      || normalized === 'plug'
      || normalized === 'plug type'
      || normalized === 'tipo de enchufe'
      || normalized === 'tipo di spina'
      || normalized === 'steckertyp';
  }

  function countryCode(root) {
    try {
      if (root && root.Shopify && root.Shopify.country) return String(root.Shopify.country).toUpperCase();
    } catch (error) {
      return '';
    }
    return '';
  }

  function defaultPlugKeyword(code) {
    var country = String(code || '').toUpperCase();
    if (country === 'US' || country === 'CA' || country === 'MX') return 'ameri';
    if (country === 'GB' || country === 'IE') return 'brit';
    return 'europ';
  }

  function plugValues(product, position) {
    var values = [];
    if (!product || !Array.isArray(product.variants) || !position) return values;

    product.variants.forEach(function (variant) {
      var value = Array.isArray(variant.options) ? variant.options[position - 1] : null;
      if (value && values.indexOf(value) < 0) values.push(value);
    });

    return values;
  }

  function matchPlugValue(product, position, keyword) {
    return plugValues(product, position).find(function (value) {
      return stripAccents(normalize(value)).indexOf(keyword) >= 0;
    }) || '';
  }

  function handleFromPath(path) {
    var match = String(path || '').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function variantIdFromSearch(search) {
    var value = new URLSearchParams(search || '').get('variant') || '';
    return /^\d+$/.test(value) ? value : '';
  }

  function plugPosition(product) {
    if (!product || !Array.isArray(product.options)) return 0;

    var index = product.options.findIndex(isPlugOption);
    return index < 0 ? 0 : index + 1;
  }

  function findVariantByOptions(product, values) {
    if (!product || !Array.isArray(product.variants) || !Array.isArray(values)) return null;
    if (values.length !== product.options.length || values.some(function (value) { return !value; })) return null;

    return product.variants.find(function (variant) {
      return Array.isArray(variant.options) && variant.options.every(function (option, index) {
        return option === values[index];
      });
    }) || null;
  }

  function findVariantById(product, id) {
    if (!id || !product || !Array.isArray(product.variants)) return null;

    return product.variants.find(function (variant) {
      return String(variant.id) === String(id);
    }) || null;
  }

  function gateState(chosen, variant, variantInputValues) {
    if (!chosen) return 'pending';
    if (!variant) return 'unavailable';

    var expectedId = String(variant.id);
    var inputsReady = variantInputValues.length > 0 && variantInputValues.every(function (value) {
      return String(value) === expectedId;
    });

    if (!inputsReady) return 'resolving';
    return variant.available ? 'available' : 'soldout';
  }

  function readProduct(section) {
    var json = section.querySelector('.product-json');
    if (!json) return null;

    try {
      return JSON.parse(json.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function readConfig(section) {
    var form = section.querySelector('[data-product-form]');
    if (!form) return {};

    try {
      return JSON.parse(form.dataset.productForm || '{}');
    } catch (error) {
      return {};
    }
  }

  function radioInputs(section, position) {
    return Array.prototype.slice.call(
      section.querySelectorAll('input[type="radio"][data-position="' + position + '"]')
    );
  }

  function nativeSelect(section, position) {
    return Array.prototype.find.call(section.querySelectorAll('select.js-variant-selector'), function (select) {
      return Boolean(select.querySelector('option[data-position="' + position + '"]'));
    }) || null;
  }

  function showPlugControl(section, position) {
    var radios = radioInputs(section, position);
    var radioWrapper = radios[0] && radios[0].closest('.js-variant-selector');
    var select = nativeSelect(section, position);
    var selectWrapper = select && select.closest('.product-form__input');

    [radioWrapper, selectWrapper].forEach(function (wrapper) {
      if (!wrapper) return;
      wrapper.hidden = false;
      wrapper.removeAttribute('aria-hidden');
      wrapper.setAttribute('data-mm-plug-choice-control', 'true');
    });
  }

  function setPlugLabel(section, position, value) {
    var label = section.querySelector('#selected-option-' + position);
    if (label && label.textContent !== value) label.textContent = value;
  }

  function writeVariantInputs(section, variant) {
    if (!variant) return;

    section.querySelectorAll('.formVariantId').forEach(function (input) {
      input.value = String(variant.id);
    });
  }

  function clearImplicitPlug(section, position) {
    showPlugControl(section, position);

    radioInputs(section, position).forEach(function (input) {
      input.checked = false;
      input.removeAttribute('checked');
    });

    var select = nativeSelect(section, position);
    if (select) {
      var placeholder = select.querySelector('[data-mm-plug-placeholder]');
      if (!placeholder) {
        placeholder = section.ownerDocument.createElement('option');
        placeholder.value = '';
        placeholder.textContent = CHOICE_LABEL;
        placeholder.disabled = true;
        placeholder.setAttribute('data-mm-plug-placeholder', 'true');
        select.insertBefore(placeholder, select.firstChild);
      }
      placeholder.selected = true;
      select.value = '';
    }

    setPlugLabel(section, position, CHOICE_LABEL);
  }

  function preselectPlug(root, section, state) {
    if (state.chosen || !state.product || !state.position) return false;

    var value = matchPlugValue(state.product, state.position, defaultPlugKeyword(countryCode(root)));
    if (!value) return false;

    showPlugControl(section, state.position);

    var control = null;

    var radio = radioInputs(section, state.position).find(function (input) {
      return input.value === value && !input.disabled;
    });

    if (radio) {
      radio.checked = true;
      control = radio;
    } else {
      var select = nativeSelect(section, state.position);
      var option = select && Array.prototype.find.call(select.options, function (item) {
        return item.value === value && !item.disabled;
      });

      if (option) {
        select.value = value;
        control = select;
      }
    }

    if (!control) return false;

    state.chosen = true;
    setPlugLabel(section, state.position, value);

    var variant = findVariantByOptions(state.product, selectedValues(section, state.product));
    if (variant) writeVariantInputs(section, variant);

    control.dispatchEvent(new Event('change', { bubbles: true }));

    return true;
  }

  function selectedValue(section, position) {
    var radio = section.querySelector(
      'input[type="radio"][data-position="' + position + '"]:checked'
    );
    if (radio) return radio.value;

    var select = nativeSelect(section, position);
    if (!select || !select.selectedOptions[0]) return '';
    return select.selectedOptions[0].value || '';
  }

  function selectedValues(section, product) {
    return product.options.map(function (_name, index) {
      return selectedValue(section, index + 1);
    });
  }

  function variantInputValues(section) {
    return Array.prototype.map.call(section.querySelectorAll('.formVariantId'), function (input) {
      return input.value;
    });
  }

  function renderGate(section, state, variant) {
    var config = state.config;
    var label = CHOICE_LABEL;
    var disabled = true;

    if (state.gate === 'resolving') {
      label = RESOLVING_LABEL;
    } else if (state.gate === 'available') {
      label = config.button || 'Ajouter au panier';
      disabled = false;
    } else if (state.gate === 'soldout') {
      label = config.sold_out || 'Victime de son succès';
    } else if (state.gate === 'unavailable') {
      label = config.unavailable || 'Indisponible';
    }

    section.dataset.mmPlugChoiceState = state.gate;
    section.classList.toggle('mm-plug-choice-blocked', disabled);

    section.querySelectorAll('.js-ajax-submit').forEach(function (button) {
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      button.value = label;
      if (button.textContent.trim() !== label) button.textContent = label;
    });

    if (variant && state.chosen) {
      setPlugLabel(section, state.position, variant.options[state.position - 1]);
    }
  }

  function sync(section, state) {
    if (!state.chosen) {
      clearImplicitPlug(section, state.position);
      state.variant = null;
      state.gate = 'pending';
      renderGate(section, state, null);
      return;
    }

    showPlugControl(section, state.position);
    var variant = findVariantByOptions(state.product, selectedValues(section, state.product));
    state.variant = variant;
    state.gate = gateState(true, variant, variantInputValues(section));

    if (state.gate === 'resolving' && state.autoSelected && variant) {
      writeVariantInputs(section, variant);
      state.gate = gateState(true, variant, variantInputValues(section));
    }

    renderGate(section, state, variant);
  }

  function changedPosition(target) {
    if (target.matches('input[type="radio"][data-position]')) {
      return Number(target.dataset.position);
    }

    if (target.matches('select.js-variant-selector')) {
      var option = target.selectedOptions[0];
      return option ? Number(option.dataset.position) : 0;
    }

    return 0;
  }

  function focusPlug(section, position) {
    showPlugControl(section, position);
    var control = radioInputs(section, position).find(function (input) { return !input.disabled; }) || nativeSelect(section, position);
    if (control && typeof control.focus === 'function') control.focus();
  }

  function installStyle(doc) {
    if (doc.getElementById('mm-lamp-plug-choice-style')) return;

    var style = doc.createElement('style');
    style.id = 'mm-lamp-plug-choice-style';
    style.textContent = '.mm-plug-choice-blocked .shopify-payment-button{display:none!important;}';
    doc.head.appendChild(style);
  }

  function start(root) {
    var doc = root.document;
    var states = new WeakMap();

    installStyle(doc);

    function schedule(section, state) {
      if (state.syncScheduled) return;
      state.syncScheduled = true;
      root.setTimeout(function () {
        state.syncScheduled = false;
        sync(section, state);
      }, 0);
    }

    function initialize(section) {
      if (!section || states.has(section)) return;

      var product = readProduct(section);
      var position = plugPosition(product);

      if (!product || !position) return;

      var explicitId = variantIdFromSearch(root.location.search);
      var explicitVariant = findVariantById(product, explicitId);

      var state = {
        product: product,
        position: position,
        chosen: Boolean(explicitVariant),
        autoSelected: false,
        config: readConfig(section),
        variant: explicitVariant || null,
        gate: 'pending',
        syncScheduled: false
      };

      states.set(section, state);

      state.autoSelected = preselectPlug(root, section, state);
      sync(section, state);

      var observer = new MutationObserver(function () {
        schedule(section, state);
      });
      observer.observe(section, { childList: true, subtree: true });
      state.observer = observer;
    }

    function initializeAll(scope) {
      if (scope.matches && scope.matches('[data-main-product]')) initialize(scope);
      if (scope.querySelectorAll) scope.querySelectorAll('[data-main-product]').forEach(initialize);
    }

    doc.addEventListener('change', function (event) {
      var section = event.target.closest && event.target.closest('[data-main-product]');
      var state = section && states.get(section);
      if (!state) return;

      var position = changedPosition(event.target);
      if (position) {
        if (position === state.position) state.chosen = true;
        if (state.chosen) {
          state.gate = 'resolving';
          renderGate(section, state, null);
        }
      }

      if (position || event.target.matches('.formVariantId')) schedule(section, state);
    }, true);

    doc.addEventListener('submit', function (event) {
      var section = event.target.closest && event.target.closest('[data-main-product]');
      var state = section && states.get(section);
      if (!state) return;

      sync(section, state);
      if (state.gate === 'available') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      focusPlug(section, state.position);
    }, true);

    doc.addEventListener('click', function (event) {
      var paymentButton = event.target.closest && event.target.closest('.shopify-payment-button');
      var section = paymentButton && paymentButton.closest('[data-main-product]');
      var state = section && states.get(section);
      if (!state || state.gate === 'available') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      focusPlug(section, state.position);
    }, true);

    doc.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    initializeAll(doc);
  }

  return {
    CHOICE_LABEL: CHOICE_LABEL,
    RESOLVING_LABEL: RESOLVING_LABEL,
    normalize: normalize,
    stripAccents: stripAccents,
    isPlugOption: isPlugOption,
    countryCode: countryCode,
    defaultPlugKeyword: defaultPlugKeyword,
    plugValues: plugValues,
    matchPlugValue: matchPlugValue,
    handleFromPath: handleFromPath,
    variantIdFromSearch: variantIdFromSearch,
    plugPosition: plugPosition,
    findVariantByOptions: findVariantByOptions,
    findVariantById: findVariantById,
    gateState: gateState,
    writeVariantInputs: writeVariantInputs,
    preselectPlug: preselectPlug,
    start: start
  };
});
